import axios, { AxiosInstance, AxiosResponse } from "axios";
import getEnvironDomain from "ati-utils/getEnvironDomain";
import {
 GetProfileType, GetAccountType, GetLoansType, PostLoanType, ValidateEmailType, PostLoansViewType,
} from "./types";
import "../globalTypes";

export class Api {
  private client: AxiosInstance;

  constructor(apiUrl?) {
    this.client = axios.create({
      baseURL: apiUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  clientWrapper = <ResponseModel>(method, url, data?, config = {}): Promise<AxiosResponse<ResponseModel>> => {
    const clientResult = this.client[method]<ResponseModel>(url, data, config);
    clientResult
      .catch((err) => {
        if (err.response?.status === 401) {
          this.handleRedirect();
        } else {
          const error = new Error(err);
          error.name = "Backend error";
          error.message = `Метод ${method}:${url} отдал ${err?.response?.status}`;
          if (window.Sentry && process.env.SENTRY_ENABLE) {
            window.Sentry.setTag("team", process.env.TEAM_TAG);
            window.Sentry.setContext("API", {
              method,
              url,
              status: err?.response?.status,
              request: JSON.stringify(data, null, 2),
              response: JSON.stringify(err?.response?.data, null, 2),
            });
          }
          throw error;
        }
      });

    return clientResult;
  };

  handleRedirect = (): void => {
    const next = window.location.href;
    window.location.href = `//id.${getEnvironDomain()}/login/?next=${next}`;
  };

  getProfile = () => this.clientWrapper<GetProfileType>("get", "/webapi/profile/v1/profile");
  getAccount = () => this.clientWrapper<GetAccountType>("get", "/webapi/firms/v1.0/account");
  getLoans = () => this.clientWrapper<GetLoansType>("get", "/gw/bridge-capital/v1/loanInfos");
  postLoans = (data) => this.clientWrapper<PostLoanType>("post", "/gw/bridge-capital/v1/loanRequests", data);
  validationEmail = (data) => this.clientWrapper<ValidateEmailType>("post", "/webapi/firms/v1.0/firms/validation/email", data);
  postLoansView = (data) => this.clientWrapper<PostLoansViewType>("post", "/gw/bridge-capital/v1/loanInfos/view", data);
}

const api = new Api();

export default api;
